import apiJaringan from '@/api/vo-general/jaringan';

const defaultState = () => ({
	genealogyList: [],
	sponsorData: {},
	sponsorList: [],
	sponsorPagination: {},
	netgrowData: {},
	netgrowList: [],
	netgrowPagination: {},
	downlineList: [],
	downlinePagination: {},
});

const state = defaultState();

const getters = {
};

const mutations = {
	setGenealogyList(state, data) {
		state.genealogyList = data.results;
  },
	setSponsorList(state, data) {
		state.sponsorData = data
		state.sponsorList = data.results
		state.sponsorPagination = data.pagination
	},
	setNetgrowList(state, data) {
		state.netgrowData = data
		state.netgrowList = data.results
		state.netgrowPagination = data.pagination
	},
	setDownlineList(state, data) {
		state.downlineList = data.results
		state.downlinePagination = data.pagination
	},
};

const actions = {
	getGenealogyList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getGenealogyList(params).then((results) => {
				const data = results.data.data
				commit('setGenealogyList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addRegistration({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addRegistration(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSponsorList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getSponsorList(params).then((results) => {
				const data = results.data.data
				commit('setSponsorList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getNetgrowList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getNetgrowList(params).then((results) => {
				const data = results.data.data
				commit('setNetgrowList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDownlineList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getDownlineList(params).then((results) => {
				const data = results.data.data
				commit('setDownlineList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};